import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

export default function Navbar() {
  const { t } = useTranslation();
  const location = useLocation();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isHomePage = location.pathname === '/';

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all ${
      isScrolled || !isHomePage ? 'bg-[#1e2025]/95 backdrop-blur-md shadow-lg border-b border-gray-800' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <div className="w-10 h-10 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center">
              <i className="ri-image-ai-line text-2xl text-white"></i>
            </div>
            <span className="text-xl font-black text-white">AnyPicAI</span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            <Link 
              to="/" 
              className={`text-base font-bold transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === '/' ? 'text-primary' : 'text-gray-300 hover:text-white'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link 
              to="/generator" 
              className={`text-base font-bold transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === '/generator' ? 'text-primary' : 'text-gray-300 hover:text-white'
              }`}
            >
              {t('nav.generator')}
            </Link>
          </div>

          {/* Right Section */}
          <div className="flex items-center gap-4">
            <LanguageSwitcher />

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden p-2 text-gray-300 hover:text-white transition-colors cursor-pointer"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-[#1e2025] border-t border-gray-800 animate-fadeIn">
          <div className="px-4 py-4 space-y-3">
            <Link 
              to="/" 
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block px-4 py-3 rounded-xl font-bold transition-colors cursor-pointer ${
                location.pathname === '/' ? 'bg-primary/10 text-primary' : 'text-gray-300 hover:bg-[#252830]'
              }`}
            >
              {t('nav.home')}
            </Link>
            <Link 
              to="/generator" 
              onClick={() => setIsMobileMenuOpen(false)}
              className={`block px-4 py-3 rounded-xl font-bold transition-colors cursor-pointer ${
                location.pathname === '/generator' ? 'bg-primary/10 text-primary' : 'text-gray-300 hover:bg-[#252830]'
              }`}
            >
              {t('nav.generator')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}